// src/AuthService.js
import { UserManager } from "oidc-client-ts";

let userManager = null;

export function getTenantId() {
  return sessionStorage.getItem("tenantId") || "default-tenant";
}

export function setTenantId(tenantId) {
  sessionStorage.setItem("tenantId", tenantId);
}

export function getUserManager() {
  const tenantId = getTenantId();
  if (!userManager) {
    userManager = new UserManager({
      authority: "https://auth.nap-pro.com",
      client_id: "c58bff17-8577-4047-a033-2504dfca1013",
      redirect_uri: `${window.location.origin}/callback`,
      response_type: "code",
      scope: "openid offline_access profile email",
      extraQueryParams: { tenantId },
      extraTokenParams: { tenantId }, 
      loadUserInfo: false,
    });
  }
  return userManager;
}